import { RemoteAdvertisingList } from 'data/usecases';
import { AdvertisingListUseCaseInterface } from 'domain/usecases';
import { makeApiUrlEntities } from 'main/factories/http/api-url-factory';
import { makeAxiosHttpClient } from 'main/factories/http/axios-http-client-factory';

export const makeAdvertisingList = (): AdvertisingListUseCaseInterface =>
  new RemoteAdvertisingList(makeApiUrlEntities(), makeAxiosHttpClient());
